import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '../icons/logo';
import { ItComponent } from '../icons/it';
import { EnComponent } from '../icons/en';
import { LocaleService } from '../../services/locale';

@Component({
  selector: 'app-index',
  imports: [RouterOutlet, CommonModule, LogoComponent, ItComponent, EnComponent],
  template: `
    <div class="flex min-h-screen flex-col lg:flex-row">
      <!-- Form Section -->
      <div class="w-full lg:w-1/2 min-h-screen lg:min-h-0 px-4 py-6 sm:px-8 sm:py-8 md:px-12 md:py-10 lg:px-16 lg:py-12 flex flex-col gap-6 overflow-y-auto bg-white">
        <div class="flex justify-between items-center">
          <app-logo></app-logo>
          <div class="flex items-center gap-2">
            <div
              *ngIf="language === 'italian'"
              (click)="switchLanguage()"
              class="p-2 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
            >
              <app-it></app-it>
            </div>
            <div
              *ngIf="language === 'english'"
              (click)="switchLanguage()"
              class="p-2 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
            >
              <app-en></app-en>
            </div>
          </div>
        </div>
        <div class="flex-1 flex flex-col justify-center max-w-md mx-auto w-full lg:max-w-none lg:mx-0">
          <router-outlet></router-outlet>
        </div>
      </div>
      <!-- Image Section -->
      <div class="hidden lg:block lg:w-1/2 h-screen sticky top-0">
        <img src="images/welcome.png" class="object-cover h-full w-full" alt="Welcome" />
      </div>
    </div>
  `
})
export class Index {
  localeService = inject(LocaleService);
  language = this.localeService.getLanguage();

  switchLanguage() {
    this.localeService.switchLocale();
    window.location.reload();
  }
}
